import React from 'react'
import { usePaletteTheme } from '../../context/paletteTheme'
import ButtonActive from './ButtonActive'

export default function Button(props) {
    const { colors } = usePaletteTheme()

    const buttonOutline = props.outlinecolor 
        ? `inset 0px 0px 0px 2px  ${props.outlinecolor}`
        : `inset 0px 0px 0px 3px  ${colors.ctaPrimary}`

    return (
        <ButtonActive
            variant={props.$active ? "contained" : "outlined"}
            color={props.$active ? "secondary" : "primary"}
            classes={{root: props?.root}}
            outline={buttonOutline}
            {...props}
            size="small"
        >
            {props.children}
        </ButtonActive>
      )
}